import { memo } from 'react';
import { useController } from 'react-hook-form';

import { MatrixPicker } from '../../MatrixPicker';
import { ControllerProps } from './Controller.types';

export const Controller = memo<ControllerProps>((props) => {
    const { name, control, defaultValue, rules, shouldUnregister, ...restProps } = props;

    const {
        field: { onChange, value, ref },
        fieldState: { invalid },
    } = useController({
        name,
        control,
        defaultValue,
        rules,
        shouldUnregister,
    });

    return <MatrixPicker {...restProps} value={value} ref={ref} name={name} invalid={invalid} onChange={onChange} />;
});

Controller.displayName = 'MatrixPicker.Controller';
